import { render, staticRenderFns } from "./WaitListRemove.vue?vue&type=template&id=1fb2be64&scoped=true"
import script from "./WaitListRemove.vue?vue&type=script&lang=js"
export * from "./WaitListRemove.vue?vue&type=script&lang=js"
import style0 from "./WaitListRemove.vue?vue&type=style&index=0&id=1fb2be64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2be64",
  null
  
)

export default component.exports